import { noop } from 'lodash';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';

import { INFO_SPACING } from '../../constants';
import { PromptModelTestCase } from '../../types/deprecated';

export const ReviewLlmOutput = ({
  testCase,
}: {
  testCase: PromptModelTestCase;
}) => {
  const intl = useIntl();

  if (!testCase.llmOutput) {
    return null;
  }

  return (
    <Layout align="flex-start" spacing={INFO_SPACING}>
      <Text flex={infoLabelFlex} variant="body-bold">
        {intl.formatMessage({
          id: 'ReviewLlmOutput.llmOutput',
          defaultMessage: 'LLM Output',
          description: 'Label for LLM output section',
        })}
      </Text>
      <TextArea
        readOnly
        enableAutoResize={false}
        name="llm-output"
        rows={5}
        value={JSON.stringify(JSON.parse(testCase.llmOutput), null, 2)}
        onChange={noop}
      />
    </Layout>
  );
};

const infoLabelFlex = '0 0 100px';
